window.Shopify.currency = {
  ...window.Shopify.currency,
  icon: '$',
  lengthUnit: '"',
  lengthRate: 1
};
if (window.Shopify.routes.root == '/') {
  window.Shopify.currency = {
    ...window.Shopify.currency,
    icon: '$',
    lengthUnit: '"',
    lengthRate: 1
  };
}
if (window.Shopify.routes.root.includes('uk')) {
  // 英国
  window.Shopify.currency = {
    ...window.Shopify.currency,
    icon: '￡',
    lengthUnit: 'cm',
    lengthRate: 2.54
  };
}
if (window.Shopify.routes.root.includes('de')) {
  // 德国
  window.Shopify.currency = {
    ...window.Shopify.currency,
    icon: '€',
    lengthUnit: 'cm',
    lengthRate: 2.54
  };
}

function matchNum (str = '') {
  // 匹配整数、小数（含小数点前后数字）
  const match = str.toString().match(/\d+\.?\d*|\.\d+/);
  if (match) {
    return parseFloat(match[0]) || 0;
  }
  return 0; // 明确返回默认值
}

function getIOSType () {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/iphone/.test(userAgent)) return "iPhone";
  if (/ipad/.test(userAgent)) return "iPad";
  if (/ipod/.test(userAgent)) return "iPod";
  return false; // 非iOS设备
}

function measurementMsgChange (header, coll) {
  const isPleated = ['French Pinch Pleat', 'Inverted Box Pleat', 'Goblet', 'Euro Pleat'];
  var tipType = false;
  var tipText = [];

  const params = {
    isDoor: false,
    isCurtain: false,
    isSoundproof: false,
    isSheer: false,
    [`is${coll}`]: true
  };

  tipText.push(`<p>Panel Width = Desired Curtain Coverage Width * <a href="/pages/curtain-measurement" target="_blank">Fullness Ratio</a> / Panel Quantity</p>`);
  tipText.push(`According to your chosen header type (${header}), we recommend a fullness ratio of `);
  if (header.includes('Grommet Top')) {
    tipText.push(`1.5x to 1.8x.`);
    tipType = true;
  }
  if (header.includes('Rod Pocket')) {
    if (params.isSoundproof) {
      // 是否隔音
      tipText.push(`1.2x.`);
    } else if (params.isSheer) {
      // 是否为纱
      tipText.push(`1.8x to 2x.`);
    } else {
      tipText.push(`1.5x.`);
    }
    tipType = true;
  }
  const isPleatedType = isPleated.filter(item => {
    return header.includes(item);
  }).length > 0;
  if (isPleatedType) {
    tipText.push(`1.1x.<br />We suggest selecting the finished width at a 1.1x ratio, as the curtain already includes 2.0-2.3x fullness sewn into the pleats.`);
    tipType = true;
  }
  if (header.includes('Pleat Hook')) {
    tipText.push(`1.5x to 1.8x.`);
    tipType = true;
  }

  if (!tipType) {
    tipText = [`<p>Panel Width = Desired Curtain Coverage Width * <a href="/pages/curtain-measurement" target="_blank">Fullness Ratio</a> / Panel Quantity</p>`];
  }

  if (params.isDoor) {
    tipText = [];
  }

  return tipText.join('');
}

function measurementMsgChange1 (header, coll) {
  const isPleated = ['French Pinch Pleat', 'Inverted Box Pleat', 'Goblet', 'Euro Pleat'];
  var tipType = false, isDoor = false, isCurtain = false, isSoundproof = false, isSheer = false;
  var tipText = [];

  switch (coll) {
    case 'Door':
      isDoor = true;
      break;
    case 'Curtain':
      isCurtain = true;
      break;
    case 'Soundproof':
      isSoundproof = true;
      break;
    case 'Sheer':
      isSheer = true;
      break;
    default:
      break;
  }

  // this[`is${coll}`] = true;

  if (header != undefined) {
    tipText.push(`Recommended fullness for ${header} header is `);
    if (header == 'Grommet Top' || header == 'Grommet Top — Silver Rings') {
      tipText.push(`1.5x to 1.8x.`);
      tipType = true;
    }
    if (header == 'Grommet Top Bottom') {
      tipText.push(`1.5x.`);
      tipType = true;
    }
    if (header == 'Velcro Tab Top' || header == 'Tab Top') {
      tipText.push(`1.2x.`);
      tipType = true;
    }
    if (header.includes('Rod Pocket')) {
      if (isSoundproof) {
        // 是否隔音
        tipText.push(`1.2x.`);
      } else if (isSheer) {
        // 是否为纱
        tipText.push(`1.8x to 2x.`);
      } else {
        tipText.push(`1.5x.`);
      }
      tipType = true;
    }
    const isPleatedType = isPleated.filter(item => {
      return header.includes(item);
    }).length > 0;
    if (isPleatedType) {
      tipText.push(`1.1x.`);
      tipType = true;
    }
    if (header.includes('Pleat Hook')) {
      tipText.push(`1.5x to 1.8x.`);
      tipType = true;
    }
  }

  if (!tipType) {
    tipText = [`<p>Panel Width = Desired Curtain Coverage Width * <a href="/pages/curtain-measurement" target="_blank">Fullness Ratio</a> / Panel Quantity</p>`];
  }

  if (isDoor) {
    tipText = [];
  }

  return tipText.join('');
}

function arrDel (arr, name) {
  const index = arr.indexOf(name);
  if (index !== -1) {
    arr.splice(index, 1);
  }
}

// 替换实体函数
function decodeHtmlEntities (str) {
  const htmlEntities = {
    '&#39;': "'",
    '&quot;': '"',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>'
  };
  return str.replace(/&#?\w+;/g, match =>
    htmlEntities[match] || match // 优先使用映射，未匹配则保留原样
  );
}

const minSpend = document.querySelector(".cart-shipping").dataset.minSpend;
const minTotal = Math.round(minSpend * (Shopify.currency.rate || 1));

function cartDataInit () {
  // 是否为 B2B 用户
  var customerType = false;
  if (typeof customer == 'object') {
    if (customer?.tags) {
      customerType = customer.tags.includes('B2B');
    }
  }

  $('.cart-shipping__message.cart-shipping__message_default').removeClass('active');
  $('.cart-shipping__message.cart-shipping__message_success').removeClass('active');

  if ($('.totals .discounts__discount').length == 0 && cartData.items.length > 0) {
    $('#CartDrawer cart-drawer-items').removeClass('is-empty');
    if (customerType) {
      $('.list-unstyled.discounts').remove();
      cartData.cart_level_discount_applications = [];
      $.each(cartData.items, function (i, item) {
        item.discounts = [];
        item.line_level_discount_allocations = [];
      })
    }
  }

  // 全局折扣
  var origin_discounts = 0;
  // 折扣
  var totalDiscount = 0;

  // 总价
  // var totalPrice = cartData.original_total_price;
  var totalPrice = 0, subTotal = 0;

  $.each(cartData.items, function (i, item) {
    var price = item.price * item.quantity || 0, newPrice = 0, discountPrice = 0, oldPrice = 0;
    // 插件多属性价格计算
    $.each(item.properties, function (j, propertie) {
      var itemPrice = 0;
      if (typeof propertie != 'object') {
        if (propertie.includes('$')) {
          itemPrice = parseFloat(propertie.split('$')[1]) * 100 * item.quantity;
        }
        if (window.Shopify.currency.icon != '$') {
          itemPrice = Math.floor(itemPrice / 100) * 100;
        }
      }
      price += itemPrice;
    });

    // 折前价
    oldPrice = cartData.items[i].oldPrice = price;

    if (customerType) {
      var customerDiscount = 0;
      if (oldPrice > 1000000) {
        customerDiscount = 25;
      }
      if (oldPrice >= 300000 && oldPrice < 1000000) {
        customerDiscount = 20;
      }
      if (oldPrice >= 100000 && oldPrice < 300000) {
        customerDiscount = 15;
      }

      if (customerDiscount > 0) {
        cartData.cart_level_discount_applications = [{
          value_type: "percentage",
          target_selection: "all",
          target_type: "line_item",
          value: `${customerDiscount.toFixed(1)}`,
          title: `${customerDiscount}% OFF`
        }];
        if ($('.discounts__discount[data-babDiscount]').length == 0) {
          $('.totals__wrapper .totals__subtotal-value').after(`<div class="discounts__wrapper"><ul class="discounts list-unstyled notranslate" role="list" aria-label="Discount"><li class="discounts__discount" data-babDiscount><div>${customerDiscount}% OFF</div><span></span></li></ul></div>`);
        }
      }
    }

    var discountList = [], couponType = false;
    $.each($(`.cart-item[data-item-id="${item.id}"] .discounts li`), function (j, discount) {
      const title = decodeHtmlEntities($(discount).text().trim().toLowerCase());
      if (!discountList.includes(title)) {
        couponType = true;
        discountList.push(title);
      }
    });
    
    // 产品折扣
    var coupon_product = [];
    if (item.discounts.length > 0) {
      $.each(item.discounts, function (j, extraItem) {
        extraItem.title = decodeHtmlEntities(extraItem.title.toLowerCase());
        var discount_codes = cartData.cart_level_discount_applications.filter((discount_code) => {
          return decodeHtmlEntities(discount_code.title).toLowerCase() != extraItem.title;
        });
        if (discount_codes.length > 0) {
          discountList = discountList.filter((discount_code) => {
            return discount_code != extraItem.title;
          });
          coupon_product.push({
            "value": matchNum(extraItem.title),
            "value_type": extraItem.title.includes('%') ? "percentage" : ""
          });
        }
      });
    }

    if (discountList.length > 0) {
      $.each(discountList, function (j, extraItem) {
        coupon_product.push({
          "value": matchNum(extraItem),
          "value_type": extraItem.includes('%') ? "percentage" : ""
        });
      });
    }

    if (coupon_product.length == 0 && $(`.cart-item[data-item-id="${item.id}"]`).attr('data-coupon') != 0) {
      coupon_product.push({
        "value": $(`.cart-item[data-item-id="${item.id}"]`).attr('data-coupon'),
        "value_type": "percentage"
      });
    }

    // 计算折扣
    console.log('开始计算产品折扣', price);
    $.each(coupon_product, function (j, coupon) {
      var coupon_price = 0;
      console.log('价格', price, 'coupon', coupon);
      if (coupon.value_type == "percentage") {
        couponType = true;
        const amount = coupon.value / 100;
        coupon_price = price * amount;
      } else {
        couponType = true;
        coupon_price = coupon.value;
      }
      price -= coupon_price;
    });
    console.log('产品折扣', price);

    if (item.discounts.length > 0 || couponType) {
      newPrice = price;
    }

    const currentPrice = item.discounts.length > 0 || couponType ? newPrice : oldPrice;

    // 计算除订单折扣外的价格
    const currentOldPrice = currentPrice + discountPrice;
    subTotal += currentOldPrice;

    cartData.items[i].original_discountPrice = currentOldPrice;
    cartData.items[i].original_line_price = currentPrice;
    cartData.items[i].original_price = currentPrice / item.quantity;

    // if (item.discounts.length > 0 || couponType) {
    //   // cart Page
    //   $(`.cart-item__totals .cart-item__old-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(oldPrice / 100).toFixed(2)}`);
    //   $(`.cart-item__totals .bcpo-cart-item-line-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(cartData.items[i].original_discountPrice / 100).toFixed(2)}`);

    //   $(`.cart-item__prices_and_totals .cart-item__old-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(oldPrice / 100).toFixed(2)}`);
    //   $(`.cart-item__prices_and_totals .bcpo-cart-item-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(cartData.items[i].original_price / 100).toFixed(2)}`);

    //   // cart-drawer
    //   $(`.cart-item__total-price .cart-item__old-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(oldPrice / 100).toFixed(2)}`);
    //   $(`.cart-item__total-price .bcpo-cart-item-line-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(cartData.items[i].original_line_price / 100).toFixed(2)}`);

    //   $(`.cart-item__line .cart-item__old-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(oldPrice / 100).toFixed(2)}`);
    //   $(`.cart-item__line .bcpo-cart-item-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(cartData.items[i].original_price / 100).toFixed(2)}`);
    // } else {
    //   $(`.cart-item__price-wrapper .bcpo-cart-item-original-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(cartData.items[i].original_price / 100).toFixed(2)}`);
    //   $(`.bcpo-cart-item-line-price .bcpo-cart-item-original-price[data-key="${item.key}"]`).text(`${window.Shopify.currency.icon}${(cartData.items[i].original_line_price / 100).toFixed(2)}`);
    // }

    if (customerType) {
      // cart Page
      $(`.bcpo-cart-item-line-price[data-key="${item.key}"]`).closest('.cart-item__totals, .cart-item__total-price').html(`${window.Shopify.currency.icon}${(cartData.items[i].original_discountPrice / 100).toFixed(2)}`);
    }
    console.log(newPrice, oldPrice);
    console.log(totalPrice);
    totalPrice += item.discounts.length > 0 || couponType ? newPrice : oldPrice;
    // totalPrice += oldPrice;
  });

  totalPrice += origin_discounts;

  // 判断自动折扣
  // const discountShowType = cartData.cart_level_discount_applications.filter((item) => {
  //   return ["Christmas Sale 10% OFF", "Christmas Sale 25% OFF"].includes(item.title);
  // });

  const discountCodeType = cartData.cart_level_discount_applications.filter((item) => {
    return item.type != '';
  });

  // if (discountShowType.length == 0) {
  //   if (discountCodeType.length == 0 && totalPrice > 0) {
  //     cartData.cart_level_discount_applications.push({
  //       "type": "",
  //       "title": "Christmas Sale 10% OFF",
  //       "value": "10.0",
  //       "total_allocated_amount": 0
  //     });
  //   } else if (totalPrice >= 120000) {
  //     cartData.cart_level_discount_applications = [{
  //       "type": "",
  //       "title": "Christmas Sale 25% OFF",
  //       "value": "25.0",
  //       "total_allocated_amount": 0
  //     }];
  //   }
  // }

  $.each(cartData.cart_level_discount_applications, function (i, item) {
    // 百分比
    // if (item.type == "" && ["Christmas Sale 10% OFF", "Christmas Sale 25% OFF"].includes(item.title)) {
    //   if (totalPrice >= 120000) {
    //     item.title = "Christmas Sale 25% OFF";
    //     item.value = "25.0";
    //   } else {
    //     item.title = "Christmas Sale 10% OFF";
    //     item.value = "10.0";
    //   }
    // }
    item.total_allocated_amount = parseInt(totalPrice * (parseFloat(item.value) / 100));
    totalDiscount += item.total_allocated_amount;
  });

  cartData.total_discount = totalDiscount;
  cartData.original_total_price = subTotal;

  // 折后价
  console.log(totalPrice, totalDiscount);
  cartData.total_price = totalPrice - totalDiscount;
  // cartData.total_price = totalPrice;

  if (customerType) {
    if (cartData.total_price > 10000) {
      // cartData.total_price = cartData.total_price * ((100 - 25) / 100);
    }
    if (cartData.total_price >= 3000 && cartData.total_price < 10000) {
      // cartData.total_price = cartData.total_price * ((100 - 20) / 100);
    }
    if (cartData.total_price >= 1000 && cartData.total_price < 3000) {
      // cartData.total_price = cartData.total_price * ((100 - 15) / 100);
    }
  }

  $('.coupon .msg, .coupon .success').css('display', 'none');
  var couponStr = [], discountStr = [], couponNum = 0;
  $.each(cartData.cart_level_discount_applications, function (i, item) {
    const price = (item.total_allocated_amount / 100).toFixed(2);
    if (item.type != "") {
      couponNum++;
      couponStr.push(`<div data-coupon="${item.title.toLowerCase()}">${item.title}`);
      couponStr.push(`<span class="close"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M9.33331 9.3335L22.6666 22.6668" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path><path d="M9.33331 22.6668L22.6666 9.3335" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path></svg></span>`);
      couponStr.push(`</div>`);
    }
    discountStr.push(`<li class="discounts__discount">`);
    discountStr.push(`<div>${item.title}</div><span class="glc-money" style="opacity:1;">-${window.Shopify.currency.icon}${price}</span>`);
    discountStr.push(`</li>`);
  });

  if (cartData.item_count > 0) {
    $('.drawer__inner-empty').css('display', 'none');
    $('.drawer cart-drawer-items').removeClass('is-empty');
    $('.header__cart .cart-count-bubble').html(`<span aria-hidden="true">(${cartData.item_count})</span><span class="visually-hidden">${cartData.item_count} items</span>`);
  }

  if ($('#CartDrawer .totals ul.discounts').length == 0) {
    $('#CartDrawer .totals').append('<ul class="discounts list-unstyled notranslate" role="list" aria-label="Discount"></ul>');
  }

  $('.discounts__wrapper > ul, #CartDrawer .totals ul.discounts').html(discountStr.join(''));
  $('.coupon .couponList').html(couponStr.join('')).css('display', couponNum > 0 ? 'flex' : 'none');

  if (localStorage.getItem("discount_code") != null) {
    const discountCode = JSON.parse(localStorage.getItem("discount_code"));
    var discountNotType = discountCode.discountArr, discountType = [];
    $.each(cartData.cart_level_discount_applications, function (i, item) {
      // arrDel(discountNotType, item.title.toLowerCase());
      if (discountCode.couponName.toLowerCase() == item.title.toLowerCase()) {
        discountType.push(item);
      }
    });
    var productDiscount = [];
    $.each(cartData.items, function (i, item) {
      const type = item.discounts.filter((discount) => {
        return discountCode.discountArr.includes(discount.title.toLowerCase());
      });
      if (type.length > 0) {
        productDiscount.push({
          index: i,
          title: type[0].title,
          oldPrice: item.oldPrice,
          line_level_total_discount: item.line_level_total_discount
        });
        discountType.push({
          "title": type[0].title,
          "total_allocated_amount": type[0].amount
        });
      }
    })
    console.log(productDiscount, discountNotType);
    $.each(productDiscount, function (i, item) {
      const old = item.oldPrice / 100;
      const newProductPrice = (item.oldPrice - item.line_level_total_discount) / 100;
      $('.cart-item').eq(item.index).find('.cart-item__price-wrapper').html(`<dl class="cart-item__discounted-prices"><span class="cart-item__old-price price">${window.Shopify.currency.icon}${old.toFixed(2)}</span><dd><span class="bcpo-cart-item-line-price price price_sale"><span class="glc-money">${window.Shopify.currency.icon}${newProductPrice.toFixed(2)}</span></span></dd></dl>`);
      $('.cart-item').eq(item.index).find('.discounts').append(`<li class="discounts__discount"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12" width="12" height="12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>${item.title.toUpperCase()}</li>`);
    })

    if (discountType.length > 0) {
      let arr = [], discountPrice = 0;
      $.each(discountType, function (i, item) {
        arrDel(discountNotType, item.title);
        arr.push(item.title.toUpperCase());
        discountPrice += item.total_allocated_amount;
      });
      $('.coupon .success span:first-of-type').html(`Coupon code '${arr.join(',')}' applied, you saved ${window.Shopify.currency.icon}${(discountPrice / 100).toFixed(2)}!`);
    }
    if (discountNotType.length > 0) {
      $('.coupon .msg').html(`Coupon code '${discountNotType.join(',').toUpperCase()}' has expired or is not applicable. Please try again.`);
    }
    $('.coupon .msg').css('display', discountNotType.length > 0 ? 'flex' : 'none');
    $('.coupon .success').css('display', discountType.length > 0 ? 'flex' : 'none');
    localStorage.removeItem('discount_code');
  }

  // $('.totals .totals__subtotal-value').html(`<span class="glc-money">${window.Shopify.currency.icon}${(cartData.original_total_price / 100).toFixed(2)}</span>`);

  // if ($('.cart_Total').length > 0) {
  //   $('.cart_Total').html(`<span>Total</span><span class="totalPrice glc-money">${window.Shopify.currency.icon}${(cartData.total_price / 100).toFixed(2)}</span>`);
  // } else {
  //   $('.totals').after(`<div class="cart_Total"><span>Total</span><span class="totalPrice glc-money">${window.Shopify.currency.icon}${(cartData.total_price / 100).toFixed(2)}</span></div>`);
  // }
  $('.totalPrice').html(`<span class="glc-money">${window.Shopify.currency.icon}${(cartData.total_price / 100).toFixed(2)}</span>`);
  $('.drawer__footer').css('display', cartData.items.length > 0 ? 'block' : 'none');
  $('#CartDrawer-Checkout').attr('disabled', cartData.items.length == 0);
  if (cartData.items.length == 0) {
    $('#CartDrawer cart-drawer-items').addClass('is-empty');
  }

  // 免运费判断
  if ((cartData.total_price / 100).toFixed(2) > 90) {
    $('.cart-shipping__message.cart-shipping__message_success').addClass('active');
  } else {
    $('.cart-shipping__message.cart-shipping__message_default').addClass('active').text(`You're ${window.Shopify.currency.icon}${Math.abs((cartData.total_price - minTotal) / 100).toFixed(2)} away from free shipping.`);
  }

  swatchCartChange();
  Product_swatchCartChange();

  $('.coupon .couponList > div svg').on('click', function () {
    const couponName = $(this).closest('div').attr('data-coupon');
    var discountArr = [];
    $.each(cartData.cart_level_discount_applications, function (i, item) {
      if (item.title.toLowerCase() != couponName) {
        discountArr.push(item.title);
      }
    })

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: discountArr.join(',') }) // 空字符串移除所有折扣
    })
      .then(res => {
        cartDataChange();
      })
  })

  // setTimeout(() => {
  //   if (cartData.item_count > 0) {
  //     var CartDrawerErrorType = false, CartErrorType = false;
  //     if ($('#CartDrawer .totals .totals__subtotal-value').length > 0) {
  //       CartDrawerErrorType = $('#CartDrawer .totals .totals__subtotal-value').text() != `${window.Shopify.currency.icon}${(cartData.original_total_price / 100).toFixed(2)}`;
  //     }
  //     CartErrorType = $('.totals .totals__subtotal-value').text() != `${window.Shopify.currency.icon}${(cartData.original_total_price / 100).toFixed(2)}`;
  //     if (CartDrawerErrorType || CartErrorType) {
  //       console.log('change error');
  //       $('.totals .totals__subtotal-value').html(`${window.Shopify.currency.icon}${(cartData.original_total_price / 100).toFixed(2)}`);
  //       cartDataChange();
  //     } else {
  //       $('.price, .totals__subtotal-value, .totalPrice, .discounts__discount span').css('opacity', 1);
  //     }
  //   }
  // }, 1000);
  subtotalChange();
}

function swatchCartChange () {
  $(`.modelSection .item`).removeClass('active');
  $('.swatchList .item .itemBox').removeAttr('loading disabled');
  $(`.modelSection .popupList .popup .popupBox`).removeClass('active');
  $('.popupList .popup .popupBox .productDetails .btn').removeAttr('loading disabled');
  const swatch = cartData.items.filter((item) => {
    return item.title.includes('Swatch');
  });
  var num = 0, str = ['<div class="isFull">Number of swatches exceeded. Please remove before checking out.</div>'];
  $.each(swatch, function (i, item) {
    num += item.quantity;
    $(`.modelSection[data-id="${item.product_id}"] .item[data-color="${item.variant_title.toLowerCase()}"]`).addClass('active');
    $(`.modelSection[data-id="${item.product_id}"] .popupList .popup .popupBox[data-color="${item.variant_title.toLowerCase()}"]`).addClass('active');
    str.push(`<div class="item" data-item-id="${item.id}">`);
    str.push(`<div class="itemBox">`);
    str.push(`<div class="imgBox">`);
    str.push(`<img loading="lazy" src="${imgUrlSize(item.image, 54)}" />`);
    str.push(`</div>`);
    str.push(`<div class="productTitle">`);
    str.push(`<div>`);
    str.push(`<span>${item.title.split(' ')[0]}</span>`);
    str.push(`<span>${item.variant_title}</span>`);
    str.push(`</div>`);
    str.push(`</div>`);
    str.push(`</div>`);
    str.push(`</div>`);
  });
  $('.swatchContainer .swatchCart .cartNum').html(`Selected Swatches (${num} / 10)`);
  $('.swatchContainer .swatchCart .cartList').html(num > 0 ? str.join('') : `<div class="isEmpty">Please select your swatches</div>`);
  $('.swatchContainer .swatchCart .btn').css('display', num > 0 ? 'flex' : 'none');

  $('.quantity__input[aria-label*="Swatches"], .quantity__input[aria-label*="Swatches"]+button').attr('disabled', num >= 10);

  $('.swatchContainer .swatchCart .cartList .item').on('click', function () {
    const id = $(this).attr('data-item-id');
    $(`#CartDrawer-CartItems .cart-item[data-item-id="${id}"] button`).click();
    // 获取元素
    const cartDrawer = document.querySelector('cart-drawer-items');

    // 安全调用检查
    if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
      cartDrawer.onCartDrawerUpdate();
    }

    setTimeout(() => {
      cartDataChange();
      swatchCartChange();
    }, 500);
  })
}

function Product_swatchCartChange () {
  $('.popupList .popup .popupBox').removeClass('active');
  $('.popupList .popup .popupBox .productDetails .btn').removeAttr('loading disabled');
  const swatch = cartData.items.filter((item) => {
    return item.title.includes('Swatch');
  });
  var num = 0;
  $.each(swatch, function (i, item) {
    num += item.quantity;

    var swatchItemBox = $(`.popupList .popup .popupBox[data-id="${item.variant_id}"][data-color="${item.variant_title.toLowerCase()}"]`);
    if (swatchItemBox.length > 0) {
      swatchItemBox.addClass('active');
    }
  });
}

async function cartDataChange () {
  try {
    const response = await fetch('/cart.js');
    cartData = await response.json();
    trackCartLogs(cartData);
    cartDataInit();
    subtotalChange();
  } catch (error) {
    console.error('Error adding product:', error);
  }
}

function subtotalChange () {
  setTimeout(() => {
    var subtotal = 0, totalPrice = matchNum($('.cart_Total .totalPrice').text().trim());
    $('.cart__checkout-button').attr('disabled', true);
    $('.drawer__inner-empty').css('display', cartData.item_count > 0 ? 'none' : 'flex');
    if (cartData.item_count > 0) {
      $('.drawer cart-drawer-items').removeClass('is-empty');
      $('.header__cart .cart-count-bubble').html(`<span aria-hidden="true">(${cartData.item_count})</span><span class="visually-hidden">${cartData.item_count} items</span>`);
      $('.cart__checkout-button').attr('disabled', false);
    }
    // $.each($('#CartDrawer .cart-item, #main-cart-items .cart-item'), function(i, item) {
    //   var priceText = $(item).find('.price:not(.price_sale)').eq(0).text().trim();
    //   if ($(item).find('.price_sale').length > 0) {
    //     priceText = $(item).find('.price_sale').eq(0).text().trim();
    //   }
    //   const price = matchNum(priceText);
    //   subtotal += price;
    // });
    // 获取元素
    const cartDrawer = document.querySelector('cart-drawer-items');

    // 安全调用检查
    if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
      cartDrawer.onCartDrawerUpdate();
    }
    $('.totals__subtotal-value, .subtotalPrice').html(`<span class="glc_money">${window.Shopify.currency.icon}${(cartData.original_total_price / 100).toFixed(2)}</span>`);
    // $('.totalPrice').html(`<span class="glc-money">${window.Shopify.currency.icon}${(cartData.total_price / 100).toFixed(2)}</span>`);
    console.log(subtotal);

    // 免运费
    $('.cart-shipping__message.cart-shipping__message_default').removeClass('active');
    $('.cart-shipping__message.cart-shipping__message_success').removeClass('active');
    // 判断
    if ((cartData.total_price / 100).toFixed(2) > 90) {
      $('.cart-shipping__message.cart-shipping__message_success').addClass('active');
    } else {
      const text = $(".cart-shipping").attr('data-message').replace('||amount||', `${window.Shopify.currency.icon}${Math.abs((cartData.total_price - minTotal) / 100).toFixed(2)}`);
      $('.cart-shipping__message.cart-shipping__message_default').addClass('active').text(text);
    }
  }, 1000);
}

function getSessionId () {
  let id = localStorage.getItem('track_session_id');
  if (!id) {
    if (crypto.randomUUID) {
      id = crypto.randomUUID(); // 或 generateUUID()
    } else {
      let str = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      id = str.replace(/[xy]/g, (c) => {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
    localStorage.setItem('track_session_id', id);
  }
  return id;
}

function trackCartLogs (cartData) {
  let isAdmin = localStorage.getItem('is_admin')
  let marketingCode = localStorage.getItem('mc')
  const data = {
    uuid: getSessionId(),
    is_admin: isAdmin,
    marketing_code: marketingCode,
    items: cartData.items,
    discount_codes: cartData.discount_codes,
  }
  if (window.location.hostname === '127.0.0.1') {
    navigator.sendBeacon('http://sitang.local.com/shopify/trackLogs/cart', JSON.stringify(data))
  } else {
    navigator.sendBeacon('https://app.thehues.com/shopify/trackLogs/cart', JSON.stringify(data))
  }
}

async function addMultipleToCart (products) {
  const results = [];
  for (const productItem of products) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: productItem.id,
          quantity: productItem.quantity,
        })
      });
      const data = await response.json();
      console.log('Added:', data);
      results.push({ status: 'success', data });
    } catch (error) {
      console.error('Error adding product:', error);
    }
  }
  cartDataChange();
  return results;
}

function productPriceChange () {
  // 有折扣的产品系列名
  const couponList = {
    '10% Sale': 10,
    '15% Sale': 15,
    '15% OFF': 15,
    '20% Sale': 20,
    '20% OFF': 20,
    '30% Sale': 30
  };
  var coupon = 0;
  $.each(product.collections, function (i, item) {
    if (couponList[item.title] > 0) {
      coupon = couponList[item.title];
    }
  });
  var arr = [];
  var panel = parseInt($('input.quantity__input').val()) || 1;
  var color = $('#bcpo .selector-wrapper [name="name0"]:checked').val() || null;
  var size = $('#bcpo .selector-wrapper [name="name1"]:checked').val() || null;
  var name2 = $('#bcpo .selector-wrapper [name="name2"]:checked').val() || null;
  var productItem = product.variants.filter((item) => {
    return item.option1 == color && item.option2 == size && item.option3 == name2;
  });
  const inputType = ['radio', 'checkbox'];
  $.each($('#bcpo .selector-wrapper:not([type="measurement"]) *[name*="properties"]'), function (i, item) {
    var type = false;
    var keys = $(item).attr('name') == 'name0' ? 'Color' : $(item).attr('name'), value = "", price = 0;
    if (!inputType.includes($(item).attr('type'))) {
      type = true;
      value = $(item).val();
      price = $(item).find(`option[value='${value}']`).attr('data-price');
    } else if (inputType.includes($(item).attr('type')) && $(item).prop("checked")) {
      type = true;
      value = $(item).val();
      price = $(item).attr('data-price');
    }
    price = parseFloat(price);
    if (type && !isNaN(price)) {
      arr.push({ "key": keys, "value": value, "price": parseInt(price) });
    }
  })

  var oldPrice = parseFloat(matchNum(product.sale_price) || 0);
  var newPrice = parseFloat(matchNum(product.regular_price) || 0);

  if (productItem.length > 0) {
    newPrice = parseFloat(productItem[0].price / 100 || 0);
  }

  $.each(arr, function (i, item) {
    newPrice += parseFloat(item.price);
    oldPrice += parseFloat(item.price);
  });
  newPrice = newPrice * panel;
  oldPrice = oldPrice * panel;

  // 全站折扣
  // coupon = 20;

  if (coupon > 0) {
    const couponNum = (100 - coupon) / 100;
    oldPrice = newPrice;
    newPrice *= couponNum;
    if (!$('.price-wrapper .price--product').hasClass('price--on-sale')) {
      $('.price-wrapper .price--product').addClass('price--on-sale');
    }
  }

  $('.price--on-sale .price-item--regular').html(`<s class="price-item price-item--regular"><span class="glc-money">${window.Shopify.currency.icon}${oldPrice.toFixed(2)}</span></s>`);
  $('.price__regular span.price-item').html(`<span class="price-item price-item--regular money" data-usd="${window.Shopify.currency.icon}${newPrice.toFixed(2)}" data-amount="${window.Shopify.currency.icon}${newPrice.toFixed(2)}"><span class="glc-money">${window.Shopify.currency.icon}${newPrice.toFixed(2)}</span></span>`);
  $('.price--on-sale .price-item.price-item--sale').html(`<span class="price-item price-item--sale money" data-usd="${window.Shopify.currency.icon}${newPrice.toFixed(2)}" data-amount="${window.Shopify.currency.icon}${newPrice.toFixed(2)}"><span class="glc-money">${window.Shopify.currency.icon}${newPrice.toFixed(2)}</span></span>`);
  $('#AddToCart .btn .price').html(`${window.Shopify.currency.icon}${product.regular_price == '' ? oldPrice.toFixed(2) : newPrice.toFixed(2)}`);
  // btnTypeChange ();
}

function btnTypeChange () {
  var btnType = false;
  $.each($('#MainContent #bcpo:not(.g-card) .selector-wrapper:not(:has([name="properties[ROOM INFO (Optional)]"]))'), function (i, item) {
    if ($(item).find('.bcpo-label .bcpo-value').text().trim().length == 0 && $(item).find('>.bcpo-label[style="display: none;"]').length == 0) {
      btnType = true;
    }
  });

  $('button[name="add to cart"]').attr('disabled', btnType);
}

function chatOpen () {
  if (window.tidioChatApi) {
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  }
}

// 根据id返回购物车数据
function findCartId (id) {
  return new Promise((resolve, reject) => {
    try {
      // 尝试从localStorage中获取购物车数据
      const cartDataStr = JSON.parse(localStorage.getItem("cartData"));
      if (cartDataStr?.data) {
        const cartData = cartDataStr.data;
        const foundItem = cartData.find((item) => item.id == id); // 使用不同的变量名
        if (foundItem) {
          // 如果找到了商品，则resolve
          resolve(foundItem);
        } else {
          // 如果没有找到商品，返回一个错误
          reject(new Error("Item not found in cart"));
        }
      }
    } catch (error) {
      // 捕获任何可能出现的错误，并reject
      reject(error);
    }
  });
}

// 计算购物车总价
function cartSUM () {
  var sum = 0;
  const cartDataStr = JSON.parse(localStorage.getItem("cartData"));
  if (cartDataStr?.data) {
    const cartData = cartDataStr.data;
    cartData.find((item) => {
      if (item._fabric_product_price != undefined) {
        sum += parseInt(item._fabric_product_price);
      } else {
        sum += item.line_total;
      }
    });
    return parseInt(sum);
  }
  return 0;
}

function updateCardList (referList, targetList) {
  $.each(referList, function (i, item) {
    $.each(Object.keys(item), function (i, itemC) {
      $.each(targetList, function (i, data) {
        if (data.id == item.id) {
          data[itemC] = item[itemC];
        }
      });
    });
  });
  return targetList;
}

function productListChange (ele, imgList, meetingDataList = dataList) {
  var $productList = $(ele);
  $productList.each(function (i, ele) {
    if ($(ele).attr("data-list") != null) {
      const modelList = $(ele).attr("data-list").split(",");
      const sameList = meetingDataList.filter(function (item) {
        return modelList.includes(item.id);
      });
      productCard(
        ele,
        listOrderByArr(sameList, modelList),
        { showType: [] },
        "Unlined",
        imgList
      );
    }
  });
}

var tagList = ["bestseller", "premiere", "editors-pick", "new-arrival"];
function productCard (
  ele,
  list,
  filterInitList = { showType: [] },
  lining = "Unlined",
  imgList = []
) {
  var str = [];
  for (var i = 0; i < list.length; i++) {
    if (imgList.length > 0) {
      list = updateCardList(imgList, list);
    }
    str.push(`<div data-src="${list[i].imgSrc}" class="item `);
    if (filterInitList.showType.length > 0) {
      $.each(Object.keys(list[i]), function (j, itemType) {
        if (filterInitList.showType.includes(itemType)) {
          var id = "";
          if (list[i][itemType] instanceof Array) {
            if (list[i][itemType][z] != "") {
              var item = " ";
              for (var z = 0; z < list[i][itemType].length; z++) {
                item += `${itemType.replace(/\//g, "-")}_${list[i][itemType][
                  z
                ].replace(/ /g, "_")}`;
                item += " ";
              }
              id = item;
            }
          } else {
            if (list[i][itemType] != "") {
              id = `${itemType.replace(/\//g, "-")}_${list[i][itemType].replace(
                / /g,
                "_"
              )}`;
              id += " ";
            }
          }
          str.push(id);
        }
      });
    }
    str.push(`" data-id="${list[i].id}">`);
    str.push(
      `<a href="${list[i].ProductUrl}" class="itemContainer">`
    );
    str.push(`<div class="productImg">`);
    str.push(`<img src="${list[i].imgSrc}">`);
    // str.push(
    //   `<img class="hoverImg" src="${
    //     list[i].hoverImg == undefined || list[i].hoverImg == ""
    //       ? list[i].imgSrc
    //       : list[i].hoverImg
    //   }">`
    // );
    str.push(`<img class="hoverImg" src="${list[i].imgSrc}">`);
    if (list[i]["tags"] != undefined) {
      const sameList = list[i]["tags"].filter(function (item) {
        return tagList.includes(item.slug);
      });
      if (sameList.length > 1) {
        console.log(list[i].ProductUrl);
      }

      if (list[i].isNewArrival) {
        str.push(`<div class="tag" type="New Arrival"></div>`);
      } else if (sameList.length > 0) {
        str.push(`<div class="tag" type="${sameList[0].name}"></div>`);
      }
    }
    str.push(`</div>`);

    str.push('<div class="productDetails">');
    str.push(`<div class="productFabrics">${list[i].Fabrics.join(" , ")}`);
    // str.push(`<div class="productColorList">`);
    // for (var j = 0; j < list[i]["_fabric_color"].length; j++) {
    //   if (j >= 4) {
    //     break;
    //   }
    //   str.push(
    //     `<img src="${list[i]["_fabric_color"][j].imgSrcF}" name="${list[i].ProductUrl}`
    //   );
    //   if (lining) {
    //     str.push(`&lining=${lining}`);
    //   }
    //   str.push(
    //     `&step_color=${list[i]["_fabric_color"][j].title}" data-src="${list[i]["_fabric_color"][j].imgSrc_n}" />`
    //   );
    // }
    // if (list[i]["_fabric_color"].length > 4) {
    //   str.push(
    //     `+${list[i]["_fabric_color"].length - 4} COLOR${
    //       list[i]["_fabric_color"].length - 4 > 1 ? "S" : ""
    //     }`
    //   );
    // }
    // str.push(`</div>`);
    str.push(`</div>`);
    if (list[i].subheading != undefined) {
      str.push(`<div class="subheading">${list[i].subheading}</div>`);
    }
    // str.push('<div class="productPrice">');
    // if (list[i].Sale) {
    //   str.push(
    //     `<span class="oldPrice">${ window.Shopify.currency.icon }${Math.round(list[i].oldPrice)}</span>`
    //   );
    // } else {
    //   str.push(`<span>${ window.Shopify.currency.icon }${Math.round(list[i].oldPrice)}</span>`);
    // }
    // if (list[i].Sale) {
    //   str.push(`<span class="discount">${list[i].Sale}</span>`);
    // }
    // if (list[i].Sale) {
    //   str.push(
    //     `<span class="newPrice">${ window.Shopify.currency.icon }${Math.round(list[i].newPrice)}</span>`
    //   );
    // }
    // str.push("</div>");
    // if (list[i].extra) {
    //   str.push(`<div class="extra">LIMITED TIME OFFER: ${list[i].extra} OFF</div>`);
    // }

    // if (list[i].AllCategory != undefined) {
    //   if (!list[i].AllCategory.includes("No Sale Coupons")) {
    //     str.push(
    //       `<div class="extra">LIMITED TIME OFFER: EXTRA 10% OFF</div>`
    //     );
    //   }
    // }

    str.push(`<h2 class="title" style="display: none;">${list[i].title}</h2>`);
    str.push(`</div>`);
    str.push(`</a>`);
    str.push(`</div>`);
  }
  if ($(ele).find(".itemCard").length > 0) {
    $(ele).find(".item:not(.itemCard)").remove();
    $(ele).find(".itemCard").after(str.join(""));
  } else {
    $(ele).html(str.join(""));
  }
  // 产品图改为正方形展示
  // $.each($(ele).find(".productImg"), function (i, item) {
  //   const ImgSrcWidth = $(item).find("> img:not(.hoverImg)").width();
  //   if (ImgSrcWidth) {
  //     $(item).css("height", `${ImgSrcWidth}px`);
  //   }
  // });
  // $(window).resize(function () {
  //   $.each($(ele).find(".productImg"), function (i, item) {
  //     const ImgSrcWidth = $(item).find("> img:not(.hoverImg)").width();
  //     if (ImgSrcWidth) {
  //       $(item).css("height", `${ImgSrcWidth}px`);
  //     }
  //   });
  // });

  $(ele)
    .find("div.productFabrics > .productColorList img")
    .hover(
      function () {
        var item = $(this).closest(".item");
        item
          .find(".productImg img:not(.hoverImg)")
          .attr("src", $(this).attr("data-src"));
      },
      function () {
        var item = $(this).closest(".item");
        item
          .find(".productImg img:not(.hoverImg)")
          .attr("src", item.attr("data-src"));
      }
    );

  $(ele)
    .find("div.productFabrics > .productColorList img")
    .on("click", function (event) {
      event.preventDefault();
      // 阻止事件冒泡
      event.stopPropagation();
      window.open($(this).attr("name"));
    });
}

function cardChange (e, productlist) {
  var $productList = $(e);
  $productList.each(function (i, ele) {
    var str = [];
    list = productlist.filter(function (item) {
      return item.id == $(ele).find(".cardItem").attr("data-id");
    });
    if (list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        str.push(`<div class="productDetails">`);
        str.push(`<div class="productFabrics">${list[i].Fabrics}`);
        str.push(`<div class="productColorList">`);
        for (var j = 0; j < list[i]["_fabric_color"].length; j++) {
          if (j >= 4) {
            break;
          }
          str.push(
            `<a href="${list[i].ProductUrl}&step_color=${list[i]["_fabric_color"][j].title}">
              <img src="${list[i]["_fabric_color"][j].imgSrcF}" data-src="${list[i]["_fabric_color"][j].imgSrc_n}" /></a>`
          );
        }
        if (list[i]["_fabric_color"].length > 4) {
          str.push(
            `+${list[i]["_fabric_color"].length - 4} COLOR${list[i]["_fabric_color"].length - 4 > 1 ? "S" : ""
            }`
          );
        }
        str.push(`</div>`);
        str.push(`</div>`);
        if (list[i].subheading != undefined) {
          str.push(`<div class="subheading">${list[i].subheading}</div>`);
        }
        str.push(`<div class="productPrice">`);
        if (list[i].Sale) {
          str.push(
            `<span class="oldPrice">${window.Shopify.currency.icon}${Math.round(list[i].oldPrice)}</span>`
          );
        } else {
          str.push(`<span>${window.Shopify.currency.icon}${Math.round(list[i].oldPrice)}</span>`);
        }
        if (list[i].Sale) {
          str.push(`<span class="discount">${list[i].Sale}</span>`);
        }
        if (list[i].Sale) {
          str.push(
            `<span class="newPrice">${window.Shopify.currency.icon}${Math.round(list[i].newPrice)}</span>`
          );
        }
        str.push(`</div>`);
        if (list[i].AllCategory != undefined) {
          if (!list[i].AllCategory.includes("No Sale Coupons")) {
            str.push(
              `<div class="extra">LIMITED TIME OFFER: EXTRA 10% OFF</div>`
            );
          }
        }
        str.push(`
          <h2 class="title" style="display: none;">${list[i].title}</h2>`);
        str.push(`</div>`);
      }
      if ($(ele).find(".cardItem .productDetails").length > 0) {
        $(ele).find(".cardItem .productDetails").remove();
      }
      $(ele)
        .find(".cardItem")
        .html(str.join(""))
        .attr("href", list[0].ProductUrl);
    }
  });
}

// 默认根据id去重
function removeDuplicates (List, keys = "id") {
  const uniqueData = {};
  List.forEach((item) => {
    if (!uniqueData[item[keys]]) {
      uniqueData[item[keys]] = item;
    }
  });
  return Object.values(uniqueData);
}

var topEvent = scrollTop > 0 ? ["header.header"] : ["header.header", ".countdown-timer-bar"];
// 页面滚动使指定元素置顶
function windowScrollTop (event, topEventList = [], fevent = "html,body") {
  topEvent = scrollTop > 0 ? ["header.header"] : ["header.header", ".countdown-timer-bar"];
  if (topEventList.length == 0) {
    topEventList = topEvent;
  }
  var item = event,
    headerHeight = 0;
  const itemScrollTop = item.offset().top;
  for (var i = 0; i < topEventList.length; i++) {
    headerHeight += parseInt($(topEventList[i]).outerHeight() || 0);
  }
  const feventScrollTop = fevent == "html,body" ? 0 : $(fevent).scrollTop();
  $(fevent).animate(
    {
      scrollTop: Math.floor(
        itemScrollTop - headerHeight - $(fevent).offset().top + feventScrollTop
      ),
    },
    150
  );
}

// 页面滚动使指定元素居中
function windowScrollToMiddle (
  event,
  topEventList = topEvent,
  fevent = "html,body",
  position = "top"
) {
  var $target = event;
  var headerHeight = 0;
  topEvent = scrollTop > 0 ? ["header.header"] : ["header.header", ".countdown-timer-bar"];

  if (topEventList.length == 0) {
    topEventList = topEvent;
  }

  for (var i = 0; i < topEventList.length; i++) {
    headerHeight += parseInt($(topEventList[i]).outerHeight() || 0);
  }

  var viewportHeight = $(window).height();
  var targetHeight = $target.outerHeight();
  var targetPosition = $target.offset().top - headerHeight;
  var scrollToPosition = "";

  switch (position) {
    case 'top':
      // 指定元素顶部居中
      scrollToPosition = targetPosition - viewportHeight / 2;
      break;
    case 'center':
      // 指定元素中心点居中
      scrollToPosition = targetPosition - (viewportHeight - targetHeight) / 2;
      break;
    default:
      break;
  }

  $(fevent).animate(
    {
      scrollTop: scrollToPosition,
    },
    150
  );
}

function windowScrollHeight () {
  return matchNum(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
}

// 判断元素是否完整在可视窗口内
// element: 元素类名; top:元素于顶部的距离
function isElementInViewport (element, top = 0) {
  var rect = element.getBoundingClientRect();
  return (
    rect.top >= top &&
    rect.left >= 0 &&
    rect.bottom <=
    (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// 获取元素在文档垂直位置的百分比
function getElementHeightPercent ($element) {
  var elementTop = $($element).offset().top; // 获取元素相对于文档的顶部位置
  // 计算元素在页面高度中的百分比位置
  var heightPercent = (elementTop / windowAbleHeight) * 100;
  heightPercent = Math.min(Math.max(heightPercent, 0), 100).toFixed(2);
  return heightPercent; // 返回百分比，保留两位小数
}

function arrRandom (arr, count) {
  var newArr = [];
  // 检查数量是否足够
  if (arr.length >= count) {
    // 随机化数组
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    newArr = arr.slice(0, count);
  } else {
    newArr = arr;
  }
  return newArr;
}

function pakoUnlock (data) {
  return JSON.parse(
    pako.inflateRaw(base64ToUint8Array(data), {
      to: "string",
    })
  );
}

// uint8array转为base64字符串
function uint8arrayToBase64 (u8Arr) {
  let CHUNK_SIZE = 0x8000; //arbitrary number
  let index = 0;
  let length = u8Arr.length;
  let result = "";
  let slice;
  while (index < length) {
    slice = u8Arr.subarray(index, Math.min(index + CHUNK_SIZE, length));
    result += String.fromCharCode.apply(null, slice);
    index += CHUNK_SIZE;
  }
  // web image base64图片格式: "data:image/png;base64," + b64encoded;
  // return  "data:image/png;base64," + btoa(result);
  return window.btoa(result);
}

// base64字符串转为uint8array数组
function base64ToUint8Array (base64String) {
  let padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  let base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
  let rawData = window.atob(base64);
  let outputArray = new Uint8Array(rawData.length);
  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function listOrderByArr (oldData, orderBy, key = 'id') {
  var idMap = {};
  oldData.forEach((item, index) => {
    idMap[item[key]] = index;
  });

  var sortedData = [];
  orderBy.forEach((id) => {
    if (idMap[id] !== undefined) {
      sortedData.push(oldData[idMap[id]]);
    }
  });
  return sortedData;
}

function copyBtn (copyText, copyBtn) {
  const defaultBtn = $(copyBtn).html();
  $(copyBtn).on("click", function () {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(copyText)
        .then(function () {
          $(copyBtn).append("COPIED");
          setTimeout(() => {
            $(copyBtn).html(defaultBtn);
          }, 3000);
        })
        .catch(function (err) {
          // 复制失败
          console.error(err);
        });
    }
  });
}

function categoriesNum (categories) {
  const cartDataStr = JSON.parse(localStorage.getItem("cartData"));
  var quantity = 0;
  if (cartDataStr?.data) {
    cartDataStr.data.filter((item) => {
      if (
        item.categories.includes(categories) &&
        !item.color.toLowerCase().includes("all color")
      ) {
        quantity += parseInt(item.quantity);
      }
    });
  }
  return quantity;
}

function categoriesNumById (id) {
  const cartDataStr = JSON.parse(localStorage.getItem("cartData"));
  var quantity = 0;
  if (cartDataStr?.data) {
    cartDataStr.data.filter((item) => {
      if (
        item.product_id == id &&
        !item.color.toLowerCase().includes("all color")
      ) {
        quantity += parseInt(item.quantity);
      }
    });
  }
  return quantity;
}

function productListCardChange (ele, productList) {
  var $productList = $(ele);
  $productList.each(function (i, ele) {
    if ($(ele).attr("data-list") != null) {
      const modelList = jQuery.unique($(ele).attr("data-list").split(","));
      const sameList = productList.filter(function (item) {
        return modelList.includes(item.id);
      });
      productCard(
        ele,
        listOrderByArr(sameList, modelList),
        {
          showType: [],
        },
        "Unlined"
      );
    }
  });
}

// 防抖函数
function debounce (func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}

// 节流函数
function throttle (func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this,
      args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

function elementCenter (ele) {
  var elementOffset = $(ele).offset(); // 获取元素相对于文档的偏移
  var elementWidth = $(ele).outerWidth();
  var elementHeight = $(ele).outerHeight();

  // 计算元素中心相对于视窗的位置
  var centerX = elementOffset.left + elementWidth / 2 - $(window).scrollLeft();
  var centerY = elementOffset.top + elementHeight / 2 - $(window).scrollTop();

  return {
    top: centerY,
    left: centerX,
  };
}

function preventScroll (event) {
  event.preventDefault();
}

// 将产品名称转换为handle格式
function convertToHandle (name) {
  return name.toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')  // 替换特殊字符为-
    .replace(/-+/g, '-')          // 合并连续-
    .replace(/^-+|-+$/g, '');     // 去除首尾-
}

// 从 URL 提取文件名
function extractFileNameFromUrl (url) {
  if (url == undefined) {
    return '';
  }
  // 确保 URL 是有效的，可以添加一个协议
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    url = 'https:' + url;
  }
  // 使用 URL 对象解析 URL
  const urlObj = new URL(url);
  // 获取路径名
  const pathName = urlObj.pathname;
  // 使用 split 方法从路径名中提取文件名
  const fileName = pathName.split('/').pop();
  return fileName;
}

// 缓存管理器（使用localStorage）
const productCache = {
  get: async (handle) => {
    const cache = localStorage.getItem(`product_${handle}`);
    if (!cache) return null;

    const { data, expires } = JSON.parse(cache);
    if (Date.now() < expires) return data;

    localStorage.removeItem(`product_${handle}`);
    return null;
  },
  set: (handle, data, ttl = 3600000) => { // 缓存1小时
    const expires = Date.now() + ttl;
    localStorage.setItem(`product_${handle}`, JSON.stringify({
      data,
      expires
    }));
  },
  clearAll: () => {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('product_')) {
        localStorage.removeItem(key);
      }
    });
  }
};

// 获取函数（带缓存）
async function getProduct (productName) {
  try {
    var response = [];
    if (window.Shopify.country == "GB") {
      productName += '-gb';
    }
    const productHandle = convertToHandle(productName);

    // 先检查缓存
    const cachedData = await productCache.get(productHandle);
    if (cachedData) return cachedData;

    // 没有缓存则发起请求
    response = await $.ajax({
      url: `/products/${productHandle}.js`,
      dataType: 'json'
    });

    // 缓存新数据
    const productData = {
      ...response,
      handle: productHandle
    };

    productCache.set(productHandle, productData);
    return productData;
  } catch (error) {
    console.error(`${productName} error:`, error.statusText);
    return null;
  }
}

// 带自动重试的获取函数
async function getProductWithRetry (productName, retries = 3) {
  for (let i = 0; i < retries; i++) {
    try {
      const product = await getProduct(productName);
      if (product) return product;
      await new Promise(res => setTimeout(res, 1000 * (i + 1)));
    } catch (error) {
      console.warn(`${i + 1} failed, Ready to try again...`);
    }
  }
  return null;
}

// 批量获取函数（带并发控制）
async function fetchMultipleProducts (productNames, concurrent = 3) {
  const results = [];
  const queue = [...productNames];

  async function worker () {
    while (queue.length > 0) {
      const name = queue.shift();
      const product = await getProductWithRetry(name);
      if (product) {
        results.push({ ...product });
      }
    }
  }

  // 创建并发工作线程
  const workers = Array.from({ length: concurrent }, () => worker());
  await Promise.all(workers);

  return results;
}

// 缓存预热函数
async function preheatCache (productNames, concurrent = 3) {
  console.log(`sum: ${productNames.length}`);
  const queue = [...productNames];

  async function worker () {
    while (queue.length > 0) {
      const name = queue.shift();
      try {
        await getProductWithRetry(name);
        console.log(`cache succeed: ${name}`);
      } catch (error) {
        console.error(`cache failed: ${name}`, error);
      }
    }
  }

  // 创建并发工作线程
  const workers = Array.from({ length: concurrent }, () => worker());
  await Promise.all(workers);

  console.log('cache finish');
}

function productCardChange (ele, productList) {
  var $productList = $(ele);
  $productList.each(function (i, ele) {
    if ($(ele).attr("data-list") != null) {
      const modelList = jQuery.unique($(ele).attr("data-list").split(","));
      const sameList = productList.filter(function (item) {
        return modelList.includes(item.name);
      });
      productCardShow(
        ele,
        listOrderByArr(sameList, modelList, 'name'),
        {
          showType: [],
        }
      );
    }
  });
}

function productCardShow (
  ele,
  list,
  filterInitList = { showType: [] },
  imgList = []
) {
  if (imgList.length > 0) {
    list = updateCardList(imgList, list);
  }
  var str = [];
  $.each(list, function (i, item) {
    str.push(`<div data-src="${item.featured_image}" class="item `);
    if (filterInitList.showType.length > 0) {
      $.each(Object.keys(item), function (j, itemType) {
        if (filterInitList.showType.includes(itemType)) {
          var id = "";
          if (item[itemType] instanceof Array) {
            if (item[itemType][z] != "") {
              var item = " ";
              for (var z = 0; z < item[itemType].length; z++) {
                item += `${itemType.replace(/\//g, "-")}_${item[itemType][
                  z
                ].replace(/ /g, "_")}`;
                item += " ";
              }
              id = item;
            }
          } else {
            if (item[itemType] != "") {
              id = `${itemType.replace(/\//g, "-")}_${item[itemType].replace(
                / /g,
                "_"
              )}`;
              id += " ";
            }
          }
          str.push(id);
        }
      });
    }
    str.push(`" data-id="${item.id}">`);
    str.push(
      `<a href="${item.url}" class="itemContainer">`
    );
    str.push(`<div class="productImg">`);
    str.push(`<img src="${item.featured_image}">`);
    // str.push(
    //   `<img class="hoverImg" src="${
    //     item.hoverImg == undefined || item.hoverImg == ""
    //       ? item.featured_image
    //       : item.hoverImg
    //   }">`
    // );
    str.push(`<img class="hoverImg" src="${item.featured_image}">`);
    if (item["tags"] != undefined) {
      const sameList = item["tags"].filter(function (item) {
        return tagList.includes(item.slug);
      });
      if (sameList.length > 1) {
        console.log(item.url);
      }

      if (item.isNewArrival) {
        str.push(`<div class="tag" type="New Arrival"></div>`);
      } else if (sameList.length > 0) {
        str.push(`<div class="tag" type="${sameList[0].name}"></div>`);
      }
    }
    str.push(`</div>`);

    str.push('<div class="productDetails">');
    str.push(`<div class="productFabrics">${item.title}`);
    str.push(`<div class="productColorList">`);
    $.each(item.product.variants, function (j, variantsItem) {
      if (j >= 4) {
        return;
      }
      console.log(variantsItem);
      str.push(
        `<img src="${variantsItem.metafields.custom.product_fabric_color}" name="${item.url}&step_color=${variantsItem.title}" data-src="${variantsItem.featured_image.src}" />`
      );
    })
    if (item.product.variants.length > 4) {
      str.push(
        `+${item.variants.length - 4} COLOR${item.variants.length - 4 > 1 ? "S" : ""
        }`
      );
    }
    str.push(`</div>`);
    str.push(`</div>`);
    // if (item.subheading != undefined) {
    //   str.push(`<div class="subheading">${item.subheading}</div>`);
    // }
    str.push('<div class="productPrice">');
    if (item.compare_at_price) {
      str.push(
        `<span class="oldPrice">${window.Shopify.currency.icon}${Math.round(item.price / 100)}</span>`
      );
    } else {
      str.push(`<span>${window.Shopify.currency.icon}${Math.round(item.price / 100)}</span>`);
    }
    if (item.compare_at_price) {
      str.push(`<span class="discount">${item.compare_at_price}</span>`);
    }
    if (item.compare_at_price) {
      str.push(
        `<span class="newPrice">${window.Shopify.currency.icon}${Math.round(item.compare_at_price / 100)}</span>`
      );
    }
    str.push("</div>");
    // if (item.extra) {
    //   str.push(`<div class="extra">LIMITED TIME OFFER: ${item.extra} OFF</div>`);
    // }

    // if (item.AllCategory != undefined) {
    //   if (!item.AllCategory.includes("No Sale Coupons")) {
    //     str.push(
    //       `<div class="extra">LIMITED TIME OFFER: EXTRA 10% OFF</div>`
    //     );
    //   }
    // }

    str.push(`<h2 class="title" style="display: none;">${list[i].title}</h2>`);
    str.push(`</div>`);
    str.push(`</a>`);
    str.push(`</div>`);
  })
  if ($(ele).find(".itemCard").length > 0) {
    $(ele).find(".item:not(.itemCard)").remove();
    $(ele).find(".itemCard").after(str.join(""));
  } else {
    $(ele).html(str.join(""));
  }
  // 产品图改为正方形展示
  // $.each($(ele).find(".productImg"), function (i, item) {
  //   const ImgSrcWidth = $(item).find("> img:not(.hoverImg)").width();
  //   if (ImgSrcWidth) {
  //     $(item).css("height", `${ImgSrcWidth}px`);
  //   }
  // });
  // $(window).resize(function () {
  //   $.each($(ele).find(".productImg"), function (i, item) {
  //     const ImgSrcWidth = $(item).find("> img:not(.hoverImg)").width();
  //     if (ImgSrcWidth) {
  //       $(item).css("height", `${ImgSrcWidth}px`);
  //     }
  //   });
  // });

  $(ele)
    .find("div.productFabrics > .productColorList img")
    .hover(
      function () {
        var item = $(this).closest(".item");
        item
          .find(".productImg img:not(.hoverImg)")
          .attr("src", $(this).attr("data-src"));
      },
      function () {
        var item = $(this).closest(".item");
        item
          .find(".productImg img:not(.hoverImg)")
          .attr("src", item.attr("data-src"));
      }
    );

  $(ele)
    .find("div.productFabrics > .productColorList img")
    .on("click", function (event) {
      event.preventDefault();
      // 阻止事件冒泡
      event.stopPropagation();
      window.open($(this).attr("name"));
    });
}

function SelectRange (event) {
  const $event = $(event);
  if ($event.find('option:first-of-type').val() == '') {
    $event.find('option:first-of-type').text('Input Size');
  }
  const minEvent = $event.find('option:not([disabled])').filter((j, optionItem) => {
    return $(optionItem).css('display') != 'none';
  })[0];
  const currentMin = $(minEvent).val().split('"')[0];
  const currentMax = $event.find('option:last-of-type').val().split('"')[0];

  return {
    "min": currentMin,
    "max": currentMax
  };
}

function currentFormatDate (inputDate = new Date()) {
  const parseDate = (input) => {
    const formats = [
      /^(\d{4})[/-](\d{2})[/-](\d{2})$/,  // YYYY/MM/DD 或 YYYY-MM-DD
      /^(\d{2})[/-](\d{2})[/-](\d{4})$/   // MM/DD/YYYY 或 MM-DD-YYYY
    ];

    for (const regex of formats) {
      const match = input.match(regex);
      if (match) {
        const [_, year, month, day] = match;
        // 统一为YYYY-MM-DD格式创建Date对象
        const date = new Date(`${year}-${month}-${day}`);
        // 验证日期有效性
        if (!isNaN(date)) return date;
      }
    }
    throw new Error('Invalid date format. Use "YYYY/MM/DD", "mm/dd/yyyy", or Date object.');
  };

  // 处理输入
  const date = typeof inputDate === 'string'
    ? parseDate(inputDate)
    : inputDate;

  // 验证日期有效性
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error('Invalid date object');
  }

  // 月份映射表（首字母大写）
  const months = {
    0: 'Jan', 1: 'Feb', 2: 'Mar', 3: 'Apr',
    4: 'May', 5: 'Jun', 6: 'Jul', 7: 'Aug',
    8: 'Sep', 9: 'Oct', 10: 'Nov', 11: 'Dec'
  };

  // 格式化输出
  return `${months[date.getMonth()]} ${String(date.getDate()).padStart(2, '0')}, ${date.getFullYear()}`;
}

function extractDate (input) {
  return input.split(' ')[0];
}

function padNumber (num) {
  return num.toString().padStart(2, '0');
}

function touchEventInit (event) {
  const $container = $(event);
  let isDragging = false;
  let startX, startY, startScrollLeft, startScrollTop;

  // 鼠标事件处理
  $container.on('mousedown', function (e) {
    isDragging = true;
    $container.addClass('dragging');
    startX = e.pageX;
    startY = e.pageY;
    startScrollLeft = $container.scrollLeft();
    startScrollTop = $container.scrollTop();
    e.preventDefault(); // 防止文字选择
  });

  $container.on('mousemove', function (e) {
    if (!isDragging) return;

    const deltaX = e.pageX - startX;
    const deltaY = e.pageY - startY;

    $container.scrollLeft(startScrollLeft - deltaX);
    $container.scrollTop(startScrollTop - deltaY);
  });

  $container.on('mouseup', function () {
    isDragging = false;
    $container.removeClass('dragging');
  });
};

function estimatedTimeChange (start, end) {
  const today = new Date();
  const dateStart = new Date();
  dateStart.setDate(today.getDate() + start);

  const dateEnd = new Date();
  dateEnd.setDate(today.getDate() + end);

  const monthsWithDots = [
    "Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.",
    "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."
  ];

  const formatDate = (date) => {
    const month = monthsWithDots[date.getMonth()];
    const day = date.getDate();
    return `${month} ${day}`;
  };

  return `${formatDate(dateStart)} - ${formatDate(dateEnd)}`;
}

function decimalToFraction (decimal, precision = 10) {
  // 限制小数位数，减少浮点误差
  const fixedDecimal = decimal.toFixed(precision);
  const [integer, decimalPart] = fixedDecimal.split('.');
  const denominator = Math.pow(10, precision);
  const numerator = parseInt(integer + decimalPart, 10);

  // 计算最大公约数
  const gcd = (a, b) => b === 0 ? a : gcd(b, a % b);
  const divisor = gcd(numerator, denominator);

  return `${numerator / divisor}/${denominator / divisor}`;
}

// 物流时效
function estimatedTimeShow (product) {
  // estimatedTimeChange(11, 16)，
  // 'Oct. 13 - Oct. 18',
  var estimatedTime = estimatedTimeChange(11, 16),
    isSwatches = false,
    isRCcoll = false,
    isMotorizedWoven = false,
    isWomanShades = false;

  if (product.collections != undefined) {
    var collectionsList = [];
    $.each(product.collections, function (i, item) {
      collectionsList.push(item.title.toLowerCase());
    });
    isSwatches = collectionsList.includes("swatches");
    isRCcoll = collectionsList.includes("the charm collection");
    isMotorizedWoven = collectionsList.includes("motorized woven shade");
    isWomanShades = collectionsList.includes("woven shades");
  } else {
    isSwatches = product.tags.includes("Swatches Sample");
    isRCcoll = product.tags.includes("ruichi");
    isMotorizedWoven = product.tags.includes("Motorized");
    isWomanShades = product.tags.includes("Woven shade");
  }

  if (isRCcoll) {
    estimatedTime = estimatedTimeChange(17, 22);
  }
  if (isWomanShades) {
    estimatedTime = estimatedTimeChange(11, 16);
    // estimatedTime = 'Oct. 18 - Oct. 23';
  }
  if (isMotorizedWoven) {
    estimatedTime = estimatedTimeChange(17, 24);
    // estimatedTime = 'Oct. 24 - Oct. 31';
  }
  if (isSwatches) {
    estimatedTime = estimatedTimeChange(9, 14);
  }

  return `Estimated Arrival Time: ${estimatedTime}`;
}

function imgUrlSize (url, size = '') {
  if (url == undefined) {
    return url;
  }

  if (size != '') {
    return url.includes('?') ? `${url}&width=${size}` : `${url}?width=${size}`;
  } else {
    return url;
  }
}

function autoScrollInit (e) {
  var $scrollable = $(e);
  var scrollInterval;
  var scrollSpeed = 1.5; // 滚动速度
  var isScrolling = false;

  $(window).scroll(function () {
    isScrolling = isElementInViewport($scrollable[0]);
  })

  // 自动滚动函数
  function autoScroll () {
    if (isScrolling) {
      var currentScroll = $scrollable.scrollLeft();
      $scrollable.scrollLeft(currentScroll + scrollSpeed);
    }
  }

  // 开始自动滚动
  function startAutoScroll () {
    scrollInterval = setInterval(autoScroll, 50);
  }

  // 停止自动滚动
  function stopAutoScroll () {
    clearInterval(scrollInterval);
  }

  // 初始化自动滚动
  startAutoScroll();

  // 鼠标移入时停止滚动
  $scrollable.on('mouseenter', function () {
    isScrolling = false;
  });

  // 鼠标移出时继续滚动
  $scrollable.on('mouseleave', function () {
    isScrolling = isElementInViewport($scrollable[0]);
  });
}

function autoStepScrollInit (e, childrenSelector = ".item", pauseTime = 4000) {
  var $scrollable = $(e);
  var $items = $scrollable.find(childrenSelector);
  var itemIndex = 0;
  var isScrolling = false;
  var scrollDuration = 600; // 滑动动画时长
  var scrollTimer = null; // 统一管理定时器

  // 获取单个元素的滚动距离（宽度 + 间隙）
  function getItemScrollDistance () {
    var firstItemWidth = $items.first().outerWidth(true);
    var gaps = $items.length > 1
      ? ($items.last().offset().left - $items.first().offset().left) - (firstItemWidth * ($items.length - 1))
      : 0;
    var avgGap = gaps / ($items.length - 1 || 1);
    return firstItemWidth + avgGap;
  }

  // 滚动到下一个子模块
  function scrollToNext () {
    if (!isScrolling) return;

    var scrollDistance = getItemScrollDistance();
    var targetLeft = $scrollable.scrollLeft() + scrollDistance;

    $scrollable.animate(
      { scrollLeft: targetLeft },
      {
        duration: scrollDuration,
        complete: function () {
          itemIndex = (itemIndex + 1) % $items.length;
        },
        easing: 'swing'
      }
    );
  }

  // 清除现有定时器并启动新的滚动周期
  function restartScrollCycle () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(autoScrollControl, pauseTime);
  }

  // 自动滚动控制函数
  function autoScrollControl () {
    if (!isScrolling) return;
    scrollToNext();
    restartScrollCycle(); // 重新计时
  }

  // 窗口滚动时更新状态
  function updateScrollState () {
    isScrolling = isElementInViewport($scrollable[0]);
  }

  // 初始化元素尺寸
  function initDimensions () {
    $items = $scrollable.find(childrenSelector);
    getItemScrollDistance();
  }

  // 启动自动滚动（安全版）
  function safeStartAutoScroll () {
    isScrolling = true;
    initDimensions();
    restartScrollCycle(); // 统一管理定时器
  }

  // 停止自动滚动（清除定时器）
  function safeStopAutoScroll () {
    isScrolling = false;
    clearTimeout(scrollTimer);
  }

  // 初始化自动滚动
  safeStartAutoScroll();

  // 鼠标事件处理
  $scrollable.on('mouseenter', safeStopAutoScroll);
  $scrollable.on('mouseleave', function () {
    if (isElementInViewport($scrollable[0])) {
      safeStartAutoScroll();
    }
  });

  // 窗口事件绑定
  $(window).on('scroll', updateScrollState);
  $(window).on('resize', function () {
    initDimensions();
    // 保持当前元素居中
    var currentItemLeft = $items.eq(itemIndex).offset().left - $scrollable.offset().left;
    $scrollable.scrollLeft($scrollable.scrollLeft() + currentItemLeft);
  });
}

function initCollapsiblePanel ({
  containerSelector,   // 外层容器选择器（原.faqList）
  itemSelector,         // 单个面板项选择器（原.faqItem）
  triggerSelector,      // 触发元素选择器（原.faqTitle）
  contentSelector       // 内容元素选择器（原.faqTitle + div）
}) {
  $(document).on('click', `${containerSelector} ${triggerSelector}`, function () {
    const $trigger = $(this);
    const $item = $trigger.closest(itemSelector);

    if ($item.hasClass('active')) {
      // 关闭当前面板
      $item.find(contentSelector).slideUp(150, () => {
        $item.removeClass('active');
      });
    } else {
      // 展开当前面板
      $item.find(contentSelector).slideDown(150, () => {
        // 关闭其他所有面板
        const $activeItems = $(containerSelector).find(itemSelector).filter('.active');
        $activeItems.find(contentSelector).slideUp(150);
        $activeItems.removeClass('active');

        // 激活当前面板
        $item.addClass('active');
      });
    }
  });
}
